export default __webpack_public_path__ + "static/media/monica_full.1ff6a361.png";